var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle208(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "379.694129641153 -3.994071866804532 22.68261931737078 23.84730401615036",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M391.44,15.85c-3.27.1-6.32-2.13-7.32-5.36-1.18-3.78.16-7.86,3.18-9.58,1.75-1,3.62-1.14,5.54-.57,5.29,1.58,7.36,9.05,3.67,13.17-1.35,1.51-3.07,2.21-5.06,2.34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle208);
export default __webpack_public_path__ + "static/media/twinkle-2-08.1e13d8a59a95df14f79e62ba9ce36e0c.svg";
export { ForwardRef as ReactComponent };